import { render } from "./TheAbout.vue?vue&type=template&id=06fb7936"
import script from "./TheAbout.vue?vue&type=script&lang=js"
export * from "./TheAbout.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PROJECTS\\2022\\school\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__